import { ConfluenceLogo } from '@atlaskit/logo';

import { token } from '@atlaskit/tokens';

import { whyAmISeeingThisRecommendationMessageDefaultReason } from '@post-office/components--ad-controls';

import { JiraYourWorkFirstPartyRecommendation } from '@post-office/components--jira-your-work-first-party-recommendation';

import { FormattedMessage, useIntl } from 'react-intl';

import { createRender } from './types';

import { type JSX } from 'react/jsx-runtime';

import { CCP_PRODUCT_ID, HAMS_PRODUCT_ID, PRODUCT_NAME } from '../../../common/constants';

const whyAmISeeingThisModalContent = {
	message: (
		<p>
			<FormattedMessage
				id="growth.recommendation-confluence.jira-your-work.reasons-modal.message"
				defaultMessage="We think {confluence} will improve your team's productivity. The recommendation is based on:"
				description="Explanation of why we think the Confluence recommendation will be relevant to the customer."
				values={{ confluence: <strong>{PRODUCT_NAME}</strong> }}
			/>
		</p>
	),
	reasons: whyAmISeeingThisRecommendationMessageDefaultReason,
};

export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }: Props) => {
		const intl = useIntl();

		return (
			<JiraYourWorkFirstPartyRecommendation
				data-testid="jira-your-work-message"
				onDismissed={onDismissed}
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
				app={{
					product: 'Confluence',
					hamsIdentifier: HAMS_PRODUCT_ID,
					ccpProductId: CCP_PRODUCT_ID,
					logo: <ConfluenceLogo size="small" appearance="brand" />,
					header: (
						<FormattedMessage
							id="growth.recommendation-confluence.jira-your-work.header"
							description="Header for Confluence recommendation message in Jira Your Work"
							defaultMessage="Get everyone on the same page"
						/>
					),
					description: (
						<FormattedMessage
							id="growth.recommendation-confluence.jira-your-work.description"
							description="Description for Confluence recommendation message in Jira Your Work"
							defaultMessage="Create a centralized space to organize requirements, release notes, goals, and more."
						/>
					),
					headerImageAltText: intl.formatMessage({
						id: 'growth.recommendation-confluence.jira-your-work.header-image-alt-text',
						description:
							'Alt text for the header image in Confluence recommendation message in Jira Your Work',
						defaultMessage:
							'Multiple people collaborating and commenting on the same page at the same time',
					}),
				}}
				iconColor={token('color.icon.inverse')}
			/>
		);
	});

export default render;
